import type { CockpitTab } from "../hooks/useCockpitTab";
import type { BentoArea } from "../components/bento/BentoGrid";
import type { CSSProperties } from "react";

// Radikal-Konsolidierung 03.07.: "geld" IST das Cockpit — Geld+Zahlen+
// Operativ fusioniert. Hierarchie (Kevin: "Zahlen, die mir direkt was
// sagen"): 1. Handeln+Cash · 2. FIRMEN in Markenfarben · 3. Netto+KPIs ·
// 4. BWA-Trend · 5. Outflow+Mahnstufen · 6. Forecast+Liqui.
// "operativ"/"zahlen" sind Legacy (useCockpitTab leitet auf geld um).
// Auftrag H Schritt 2: "actions" + "hero" leben jetzt im LageHeader
// (Ebene 1, oberhalb des Bento) — nicht mehr als Grid-Kacheln.
// Auftrag H Schritt 4: bwa/outflowHero/mahnungen/forecastHero/liquiPlanung
// wandern in die BeweisSektion-Accordions (Ebene 3) unter dem Bento.
// AUFTRAG M B1/B3: kpiUmsatz (Umsatz wohnt in den Firmen-Kacheln) +
// kpiEbit (EBIT wohnt im BWA-Accordion-Header) sind gestorben.
export const TAB_TILES: Record<CockpitTab, readonly BentoArea[]> = {
  geld: [
    "firmaDrainx",
    "firmaGundk",
    "firmaInfrax",
    "firmaXholding",
    "netto",
  ],
  buero: [],
  operativ: [],
  zahlen: [],
  team: [],
};

export function isTileVisible(tab: CockpitTab, area: BentoArea): boolean {
  const set = TAB_TILES[tab];
  return set.length === 0 || set.includes(area);
}

// Alle Areas RECHTECKIG (CSS verwirft sonst das gesamte Template —
// Live-Bug vom 03.07. im Zahlen-Tab, nie wiederholen).
const GELD_AREAS_DESKTOP = `
  "firmaDrainx firmaDrainx firmaDrainx firmaGundk firmaGundk firmaGundk firmaInfrax firmaInfrax firmaInfrax firmaXholding firmaXholding firmaXholding"
  "netto netto netto netto netto netto netto netto netto netto netto netto"
`;

const GELD_AREAS_TABLET = `
  "firmaDrainx firmaDrainx firmaDrainx firmaDrainx firmaGundk firmaGundk firmaGundk firmaGundk"
  "firmaInfrax firmaInfrax firmaInfrax firmaInfrax firmaXholding firmaXholding firmaXholding firmaXholding"
  "netto netto netto netto netto netto netto netto"
`;

// Live-Bugfix 03.07.: Die alte Version hatte eine NICHT-RECHTECKIGE
// bwa-Area (Zeile 2: Spalten 1-8, Zeile 3: Spalten 1-12). CSS verwirft
// dann das KOMPLETTE grid-template-areas (computed: none) — alle Tiles
// des Zahlen-Tabs renderten uebereinander in einer Zelle (Screenshot-
// Befund im Live-Cockpit). Regel: JEDE Area muss ein Rechteck sein.
const ZAHLEN_AREAS_DESKTOP = `
  "kpiUmsatz kpiUmsatz kpiUmsatz kpiUmsatz kpiEbit kpiEbit kpiEbit kpiEbit jaKompass jaKompass jaKompass jaKompass"
  "bwa bwa bwa bwa bwa bwa bwa bwa bwa bwa bwa bwa"
  "bwa bwa bwa bwa bwa bwa bwa bwa bwa bwa bwa bwa"
  "firmaDrainx firmaDrainx firmaDrainx firmaGundk firmaGundk firmaGundk firmaInfrax firmaInfrax firmaInfrax firmaXholding firmaXholding firmaXholding"
`;

const ZAHLEN_AREAS_TABLET = `
  "kpiUmsatz kpiUmsatz kpiUmsatz kpiUmsatz kpiEbit kpiEbit kpiEbit kpiEbit"
  "jaKompass jaKompass jaKompass jaKompass jaKompass jaKompass jaKompass jaKompass"
  "bwa bwa bwa bwa bwa bwa bwa bwa"
  "bwa bwa bwa bwa bwa bwa bwa bwa"
  "firmaDrainx firmaDrainx firmaDrainx firmaDrainx firmaGundk firmaGundk firmaGundk firmaGundk"
  "firmaInfrax firmaInfrax firmaInfrax firmaInfrax firmaXholding firmaXholding firmaXholding firmaXholding"
`;

export const TAB_GRID_DESKTOP: Partial<Record<CockpitTab, CSSProperties>> = {
  geld: {
    gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
    gridAutoRows: "160px",
    gridTemplateAreas: GELD_AREAS_DESKTOP,
    gap: "1rem",
  },
  zahlen: {
    gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
    gridAutoRows: "160px",
    gridTemplateAreas: ZAHLEN_AREAS_DESKTOP,
    gap: "1rem",
  },
};

export const TAB_GRID_TABLET: Partial<Record<CockpitTab, CSSProperties>> = {
  geld: {
    gridTemplateColumns: "repeat(8, minmax(0, 1fr))",
    gridAutoRows: "160px",
    gridTemplateAreas: GELD_AREAS_TABLET,
    gap: "0.75rem",
  },
  zahlen: {
    gridTemplateColumns: "repeat(8, minmax(0, 1fr))",
    gridAutoRows: "160px",
    gridTemplateAreas: ZAHLEN_AREAS_TABLET,
    gap: "0.75rem",
  },
};
